import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { List } from 'immutable'
import { compose, branch, renderComponent } from 'recompose'
import Input from 'shared-web/src/components/Input'
import { ProgressiveLoader } from '@driftt/tide-core-legacy'

import GetRows from 'components/customer/EndUserAttributesCard/helper'
import ContactPropertyCreatorModal from 'components/PropertyCreator'
import Header from 'components/customer/CompanyCard/Header'
import CancelAndSave from 'components/customer/CompanyCard/CancelAndSave'
import { Card as CardStyle } from 'components/customer/CompanyCard/Card.styl'
import { CardWrapper, endUserAttributesCardPlaceholder } from './style.styl'
import ViewAllAttributesButton from './ViewAllAttributesButton'
import AttributesModal from './AttributesModal'
import {
  PLACEHOLDER_PRIMARY_COLOR,
  PLACEHOLDER_SECONDARY_COLOR,
  PLACEHOLDER_PRIMARY_OPACITY,
  PLACEHOLDER_SECONDARY_OPACITY,
} from 'components/conversation/ContactSideBar'

const Icon = (
  <img
    src={require('images/svg/rolodex-navy.svg')}
    style={{ width: 16, height: 11, marginRight: 9 }}
  />
)

const EndUserAttributesCardPlaceholder = () => {
  const placeholderShape = [
    <rect key={0} x="0" y="0" width="229" height="27" rx="2"></rect>,
    <rect key={1} x="0" y="47" width="229" height="27" rx="2"></rect>,
    <rect key={2} x="0" y="94" width="229" height="27" rx="2"></rect>,
  ]

  const options = {
    height: 131,
    width: 229,
    primaryColor: PLACEHOLDER_PRIMARY_COLOR,
    secondaryColor: PLACEHOLDER_SECONDARY_COLOR,
    primaryOpacity: PLACEHOLDER_PRIMARY_OPACITY,
    secondaryOpacity: PLACEHOLDER_SECONDARY_OPACITY,
  }

  return (
    <div className={endUserAttributesCardPlaceholder}>
      <ProgressiveLoader options={options} placeholderShape={placeholderShape} numPlaceholders={1} />
    </div>
  )
}

class EndUserAttributesCard extends Component {
  static contextTypes = {
    app: PropTypes.object.isRequired
  }

  state = {
    showAttributesModal: false,
    showPropertyCreatorModal: false
  }

  showAttributesModal = () => {
    this.setState({ showAttributesModal: true })
  }

  closeAttributesModal = () => {
    this.setState({ showAttributesModal: false })
    this.props.handleCancel()
  }

  showPropertyCreatorModal = () => {
    this.setState({ showPropertyCreatorModal: true })
  }

  closePropertyCreatorModal = () => {
    this.setState({ showPropertyCreatorModal: false })
    this.props.handleCancel()
  }

  filterRows = () => {
    const { contactRows, socialRows, driftRows, customRows, enabledAttributes, handleEdit, editing } = this.props
    return List()
      .concat(contactRows)
      .concat(socialRows)
      .concat(driftRows)
      .concat(customRows)
      .filter(({ label }) => enabledAttributes.has(label))
      .map((row, i) =>
        <Attribute
          key={i}
          {...row}
          editing={editing}
          handleEdit={handleEdit}
          hideCheckBox={true}
        />)
  }

  render() {
    const {
      changed,
      editing,
      updating,
      handleCancel,
      handleSave,
      handleEdit,
    } = this.props
    const { showAttributesModal, showPropertyCreatorModal } = this.state
    const headerControl = (
      editing
      ? <CancelAndSave
          updating={updating}
          changed={changed}
          onCancel={handleCancel}
          onSave={handleSave}/>
       : <div className="link edit dsg-Body" onClick={handleEdit}>Edit</div>
    )

    return (
      <div className={`dsg-card ${CardStyle} ${CardWrapper} ${this.props.className}`}>
        <Header
          label="About"
          more={headerControl}
          icon={Icon}
        />
        {this.filterRows()}
        { this.props.hideAllAttributesModal ?
          null :
          (
            <div style={{ padding: '10 20px' }}>
              <ViewAllAttributesButton onClick={this.showAttributesModal}/>
              <button className="property-creator-modal-open-button drift-button drift-button-tertiary" onClick={this.showPropertyCreatorModal}>
                Create New Contact Attribute
              </button>
            </div>
          )
        }
        { showAttributesModal ?
          <AttributesModal
            onClose={this.closeAttributesModal}
            endUser={this.props.endUser}
          /> :
          null
        }

        {showPropertyCreatorModal &&
          <ContactPropertyCreatorModal
            onClose={this.closePropertyCreatorModal}
          />
        }
      </div>
    )
  }
}

export class Attribute extends Component {
  state = {
    isInput: null,
  }

  getInputValue() {
    const { value, handleChange } = this.props
    return (
      <Input
        className="flex-1"
        isValid={value ? value.length > 0 : true}
        valueLink={{ value, requestChange: handleChange }}
        size="small"
      />
    )
  }

  getReadOnlyValue() {
    return <div className="flex-1 dsg-body color-navy-dark">{this.props.value}</div>
  }

  getLinkValue() {
    return (
      <a className="flex-1" href={this.props.href} target="_blank">
        <div className="dsg-Body truncate">{this.props.value}</div>
      </a>
    )
  }

  getNormalValue() {
    const { value } = this.props
    return (
      <div className="flex-1 dsg-Body truncate">
        {typeof value === 'boolean' ? JSON.stringify(value) : value}
      </div>
    )
  }

  getMissingValue() {
    const { label } = this.props
    return (
      <span
        className="dsg-Body color-navy"
        onClick={this.props.handleEdit}
        style={{
          cursor: 'pointer'
        }}
      >
        Add {label}
      </span>
    )
  }

  getDisplayValue() {
    const { empty, value, href, editing, handleChange } = this.props
    if (editing) {
      if (typeof handleChange !== 'undefined') {
        return this.getInputValue()
      } else {
        return this.getReadOnlyValue()
      }
    } else {
      if (empty) {
        return this.getMissingValue()
      } else {
        if (typeof value === 'undefined' || value == null) {
          return this.getMissingValue()
        } else {
          if (typeof href !== 'undefined') {
            return this.getLinkValue()
          } else {
            return this.getNormalValue()
          }
        }
      }
    }
  }

  render() {
    const { label } = this.props
    return (
      <div key={label} style={{ padding: '10px 20px 0' }}>
        <div
          className="dsg-Small color-navy-dark dsg-medium-weight"
          style={{ paddingRight: 10 }}
        >
          {label}
        </div>
        {this.getDisplayValue()}
      </div>
    )
  }
}

export default compose(
  branch(
    props => !props.endUser,
    renderComponent(EndUserAttributesCardPlaceholder),
  )
)(GetRows(EndUserAttributesCard))



// WEBPACK FOOTER //
// ./src/scripts/components/customer/EndUserAttributesCard/index.js